import React from 'react';
import { map } from 'lodash';
import AbsoluteValue from '../../AbsoluteValue';
import PercentageValue from '../../PercentageValue';
import { percentageValue } from '../../../../helpers/NumberFormatter';

export const preAddSettings = {
	settingsForTable
};


function settingsForTable(mode){
	
	
	let columns = [
	   {
		   id: 'product',
		   Header: 'Product',
		   accessor: 'product',
	   },
	   {
		   id: 'apple',
		   Header: 'Apple Pre Adds',
		   // width: 70,
		   accessor: 'apple'
	   },
	   {
		   id: 'spotify',
		   Header: 'Spotify Pre Saves',
		   accessor: 'spotify',
	   },
	];
	return columns.map(column=>{
		//column.show = modes[mode].includes(column.id);
		return column;
	});
}